<template>
  <div class="publicPageContainer">
		<app-study-bar></app-study-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import AppStudyBar from '@/components/common/AppStudyBar';

export default {
	name: 'PageContainer',
	components: {
		'app-study-bar': AppStudyBar
	},
	props: {
	}
};
</script>

<style></style>
